import { print } from 'graphql'

import { storefrontClient } from '..'
import { RecoverCustomerDocument, type RecoverCustomerMutation } from '../__generated/storefront'

export const recoverCustomer =
  () =>
  async (email: string): Promise<void> => {
    const response = await storefrontClient.request<RecoverCustomerMutation>(
      print(RecoverCustomerDocument),
      {
        variables: {
          email,
        },
      },
    )

    const payload = response.data?.customerRecover

    if (!payload || payload.customerUserErrors.length > 0) {
      throw new Error('Failed to recover customer')
    }
  }
